import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { useNavigate } from "../../components/Navigate";
import MainLayout from "../../components/layout/MainLayout";
import ScreenWrapper from "../../components/layout/screenWrapper";
import VirtualLibrarianUserMenu from "./menu";
import VirtualLibrarianChat from "../admin/components/virtualLibrarian/chat/chatInterface";
import "../admin/virtualLibrarian.scss";
import ChatInputInterface from "../admin/components/virtualLibrarian/chat/chatInputInterface";
import ChatLandingPage from "../admin/components/virtualLibrarian/chat/chatLandingPage";
import _ from "lodash";

const VirtualLibrarian = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState("search");
  const [loadingError, setLoadingError] = useState(null);
  const [validationErrors, setValidationErrors] = useState(null);
  const [errors, setErrors] = useState(null);
  const [messages, setMessages] = useState(null);
  const [loading, setLoading] = useState(false);
  const [questionLoaded, setQuestionLoaded] = useState(
    sessionStorage.getItem("virtualLibrarianLandingInvisible") ?? false
  );
  const navigate = useNavigate();

  useEffect(() => {
    const virtualLibrarianLandingInvisible = sessionStorage.getItem(
      "virtualLibrarianLandingInvisible"
    );
    if (virtualLibrarianLandingInvisible === "false") {
      setQuestionLoaded(true);
      sessionStorage.setItem("virtualLibrarianLandingInvisible", "true");
    }
  }, []);

  const handleQuestionSubmitted = () => {
    setQuestionLoaded(true);
  };

  const handleOnMenuItemSelected = (value) => {
    setSelectedMenuItem(value);
  };

  const handleOnCancel = () => {
    navigate(`/EchoAI`);
    setLoadingError(null);
    setValidationErrors(null);
    setErrors(null);
  };

  useEffect(() => {
    window.addEventListener(
      "virtualLibrarianLandingInvisible",
      handleQuestionSubmitted
    );

    return () => {
      window.removeEventListener(
        "virtualLibrarianLandingInvisible",
        handleQuestionSubmitted
      );
    };
  }, []);

  return (
    <>
      <MainLayout
        errors={errors}
        messages={messages}
        validationErrors={validationErrors}
      >
        <ScreenWrapper
          loading={loading}
          loadingError={loadingError}
          onReturn={handleOnCancel}
          className="virtual-screen-wrapper"
        >
          {selectedMenuItem === "search" && (
            <div className="virtual-librarian-mgmt">
              <div className="virtual-librarian-mgmt-chat-container">
                <VirtualLibrarianUserMenu
                  onMenuItemSelected={handleOnMenuItemSelected}
                  selectedMenuItem={selectedMenuItem}
                />
                {questionLoaded ? (
                  <VirtualLibrarianChat mode="user" />
                ) : (
                  <ChatLandingPage />
                )}
              </div>
              {questionLoaded && <ChatInputInterface />}
            </div>
          )}
        </ScreenWrapper>
      </MainLayout>
    </>
  );
};

export default VirtualLibrarian;
